export const profileTracker = {
  actions: {
    openModalCancelProPlan:
      'Detalhes do Perfil: Abriu o Modal para cancelar plano PRO',
    cancelProPlan:
      'Detalhes do Perfil (Modal): Efetivou o cancelamento do plano PRO',
    showProfileOptions: 'Visualizar opções do perfil',
  },
}
